import { CKContainerProps } from 'clearkit';
import { Link } from 'react-router-dom';

import { routes } from '~/components/app/appMainRoutes';

import { CTA } from './CTA';

export function DidYouKnow(props: CKContainerProps) {
  return (
    <CTA {...props}>
      <CTA.Heading>Did you know?</CTA.Heading>
      <CTA.Description className="space-y-4">
        <div>
          You can <Link to={routes.targetMarkets}>define Target Markets</Link>{' '}
          and use those for prospecting into, focusing your attention and search
          on the people at companies in your entire addressable market, or in
          specific markets you care about most.
        </div>
        <a href="/">Learn more</a>
      </CTA.Description>
    </CTA>
  );
}
